module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('button', {
    staticClass: "button button-link button-nav pull-left"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left goback",
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "searchbar title searchbox"
  }, [_c('a', {
    staticClass: "searchbar-cancel cancel",
    staticStyle: {
      "color": "#808080"
    },
    on: {
      "click": _vm.cancelSearch
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('form', {
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }, [(_vm.showSearchIcon) ? _c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchWords),
      expression: "searchWords",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "search",
      "results": "0",
      "autocomplete": "off",
      "placeholder": "输入基因名称..."
    },
    domProps: {
      "value": (_vm.searchWords)
    },
    on: {
      "focus": function($event) {
        return _vm.onSearchActive(true)
      },
      "blur": [function($event) {
        return _vm.onSearchActive(false)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWords = $event.target.value.trim()
      }
    }
  })])])])]), _vm._v(" "), (_vm.showFilterBar) ? _c('div', {
    staticClass: "bar bar-header-secondary filter-bar",
    staticStyle: {
      "height": "auto",
      "overflow-x": "hidden"
    }
  }, [_vm._l((_vm.selectedItems), function(item) {
    return _c('div', {
      staticClass: "checkbox-el"
    }, [(item.selected) ? _c('label', {
      staticClass: "checkbox selected"
    }, [_vm._v(" " + _vm._s(item.word))]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-el pull-right"
  }, [(_vm.searchWords !== '') ? _c('a', {
    staticStyle: {
      "width": "2rem",
      "padding-right": "1rem"
    },
    on: {
      "click": _vm.cancelSearch
    }
  }, [_vm._v("清除搜索词")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "pull-right open-panel",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "data-panel": "#panel-right-finder"
    },
    on: {
      "click": _vm.openpanel
    }
  }, [_vm._v("筛选")])])], 2) : _vm._e(), _vm._v(" "), (!_vm.showFilterBar && _vm.searchWords !== '') ? _c('div', {
    staticClass: "bar bar-header-secondary filter-bar",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "width": "2rem"
    },
    on: {
      "click": _vm.cancelSearch
    }
  }, [_vm._v("清除搜索词")])])]) : _vm._e(), _vm._v(" "), (_vm.showStatusBar) ? _c('div', {
    staticClass: "bar bar-footer status"
  }, [_vm._v("\n    " + _vm._s(_vm.statusMsg) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [(!_vm.showMatchData) ? _c('div', {
    staticStyle: {
      "margin-left": ".8rem",
      "font-size": ".6rem"
    }
  }, [_c('div', [_vm._v("为了您更好的体验，建议您：")]), _vm._v(" "), _c('div', [_vm._v("1.NCBI Refseq数据库基因使用Official Symbol；")]), _vm._v(" "), _c('div', [_vm._v("2. microRNA请使用mirbase数据库名称,比如microRNA155,若物种为human可以转化为hsa-mir-155,hsa-mir-155-5p,hsa-mir-155-3p；")]), _vm._v(" "), _c('div', [_vm._v("3.若您使用过程中碰到任何问题,可以返回首页咨询在线客服。")])]) : _vm._e(), _vm._v(" "), (_vm.searchHistory && _vm.searchHistory.length && !_vm.showMatchData) ? _c('div', {
    staticClass: "search_history"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('div', {
    staticClass: "blueTitle"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("搜索历史")]), _vm._v(" "), _c('div', {
    staticClass: "content-block-title",
    staticStyle: {
      "margin-top": "-1.2rem",
      "margin-left": "86%",
      "color": "#f6383a"
    },
    on: {
      "click": _vm.removeSearchHistory
    }
  }, [_vm._v("清空")]), _vm._v(" "), _vm._l((_vm.searchHistory), function(item, index) {
    return (!_vm.isRemoveSH) ? _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(item, false, true)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup"
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])])]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showMatchData) ? _c('div', {
    staticClass: "list-block"
  }, [(_vm.matchData !== undefined && !_vm.isCorrections) ? _c('ul', {
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.matchData), function(searchData) {
    return _c('li', {
      staticClass: "item-content close-popup"
    }, [_c('div', {
      staticClass: "item-inner",
      on: {
        "click": function($event) {
          return _vm.searchTarget(searchData, true)
        }
      }
    }, [_c('div', {
      staticClass: "item-title close-popup",
      attrs: {
        "id": "results-goods"
      }
    }, [_vm._v("\n              " + _vm._s(searchData.text) + "\n            ")])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isCorrections && _vm.searchWords !== '') ? _c('ul', {
    staticStyle: {
      "background-color": "inherit",
      "border": "0 solid",
      "font-size": "0.6rem"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("暂时没有匹配到与\""), _c('span', {
    staticStyle: {
      "color": "#0894ec"
    }
  }, [_vm._v(_vm._s(_vm.searchWords))]), _vm._v("\"相关的线上产品信息，")]), _vm._v(" "), (_vm.isCorrections) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("您也许可以试一下关键字\n\n          "), _vm._l((_vm.matchData), function(correctData) {
    return _c('span', {
      staticStyle: {
        "color": "#0894ec",
        "margin-left": ".2rem"
      },
      on: {
        "click": function($event) {
          return _vm.searchTarget(correctData, true)
        }
      }
    }, [_c('u', [_vm._v(_vm._s(correctData.text))])])
  }), _vm._v(" \n\n        ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": ".8rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "color": "#e7e7e7"
    }
  }), _vm._v(" "), _c('div', [_vm._v("您也可以点击"), _c('span', {
    staticStyle: {
      "color": "#0894ec"
    },
    on: {
      "click": _vm.contactUs
    }
  }, [_vm._v("联系方式")])]), _vm._v(" "), _c('div', [_vm._v("或者点击"), _c('span', {
    staticStyle: {
      "color": "#0894ec"
    },
    on: {
      "click": _vm.toMessage
    }
  }, [_vm._v("在线客服")]), _vm._v("咨询")]), _vm._v(" "), _c('div', [_vm._v("我们将会为您提供更多的产品和服务信息")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.showfinderContent) ? _c('div', {
    staticClass: "content finder-content infinite-scroll",
    attrs: {
      "id": "contentscroll"
    }
  }, [(_vm.showFilter) ? _c('finderFilter', {
    attrs: {
      "findFilters": _vm.findFilters,
      "finderyemian": true
    },
    on: {
      "finderFilterSearch": _vm.finderFilterSearch
    }
  }) : _vm._e(), _vm._v(" "), _c('newMerchandiseListA', {
    ref: "”a”",
    staticClass: "list-container",
    attrs: {
      "merchList": _vm.finderResultData
    }
  }), _vm._v(" "), (_vm.finderEnd) ? _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("更多产品请联系"), _c('a', {
    on: {
      "click": _vm.toMessage
    }
  }, [_vm._v("在线客服")]), _vm._v("或者拨打400-621-0302")])]) : _c('div', {
    staticClass: "infinite-scroll-preloader",
    attrs: {
      "id": "preloader"
    }
  }, [_c('div', {
    staticClass: "preloader"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btnTop",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "btnTop",
      "href": "javascript:;",
      "title": "Back to top"
    },
    on: {
      "click": _vm.returntop
    }
  }, [_c('img', {
    staticClass: "imageTop",
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": require("../../../static/img/top.png")
    }
  })])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e7b91e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finder/Finder.vue
// module id = 1683
// module chunks = 8